var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { normalizeObject, dataLayerPush, getEhashCookie } from "../shared/utils";
/***************************
 * My Profile Events
 ***************************/
/**
 * my_profile_change_email_click
 * my_profile_change_password_click
 *
 * my_profile_communication_preferences_edit
 * my_profile_communication_preferences_save
 * my_profile_communication_preferences_cancel
 *
 * my_profile_donor_profile_edit
 * my_profile_donor_profile_save
 * my_profile_donor_profile_cancel
 *
 * */
function myProfileChangeEmailClickHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_profile", event_label: "click:Change Email", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myProfileChangePasswordClickHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_profile", event_label: "click:Reset Password", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myProfileCommPrefEditHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_profile", event_label: "edit:Communication Preferences", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myProfileCommPrefSaveHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_profile", event_label: "save:Communication Preferences", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myProfileCommPrefCancelHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_profile", event_label: "cancel:Communication Preferences", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myProfileDonorProfileEditHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_profile", event_label: "edit:Donor Profile", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myProfileDonorProfileSaveHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_profile", event_label: "save:Donor Profile", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myProfileDonorProfileCancelHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_profile", event_label: "cancel:Donor Profile", ehash: ehash }));
    dataLayerPush(dlEventData);
}
/***************************
 * My Payments Events
 ***************************/
/**
 * my_payment_info_credit_card_add_save
 * my_payment_info_credit_card_add_cancel
 * my_payment_info_credit_card_add_save_error
 *
 * my_payment_info_eft_add_save
 * my_payment_info_eft_add_cancel
 * my_payment_info_eft_add_save_error
 *
 * my_payment_info_add
 *
 * my_payment_info_credit_card_delete_cancel
 * my_payment_info_credit_card_delete
 *
 * my_payment_info_credit_card_edit_save
 * my_payment_info_credit_card_edit_cancel
 * my_payment_info_credit_card_edit_save_error
 *
 * my_payment_info_eft_edit_save
 * my_payment_info_eft_edit_cancel
 * my_payment_info_eft_edit_save_error
 *
 * my_payment_info_credit_card_edit
 * my_payment_info_eft_edit
 */
function myPaymentInfoCCAddSavelHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_payment_information", event_label: "save:Add Credit Card", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myPaymentInfoCCAddCancellHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_payment_information", event_label: "cancel:Add Credit Card", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myPaymentInfoCCAddSaveErrorlHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject({
        supporter_id: eventData.supporter_id,
        error_message: eventData.errorMessage || "",
        error_type: eventData.errorType || "",
        page_errors: 1,
        total_errors: 1,
        event: "my_account_interactions",
        event_category: "my_account",
        event_action: "my_payment_information",
        event_label: eventData.errorMessage,
        ehash: ehash
    });
    dataLayerPush(dlEventData);
}
function myPaymentInfoEFTAddSavelHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_payment_information", event_label: "save:Add EFT", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myPaymentInfoEFTAddCancellHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_payment_information", event_label: "cancel:Add EFT", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myPaymentInfoEFTAddSaveErrorlHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject({
        supporter_id: eventData.supporter_id,
        error_message: eventData.errorMessage || "",
        error_type: eventData.errorType || "",
        page_errors: 1,
        total_errors: 1,
        event: "my_account_interactions",
        event_category: "my_account",
        event_action: "my_payment_information",
        event_label: eventData.errorMessage,
        ehash: ehash
    });
    dataLayerPush(dlEventData);
}
function myPaymentInfoAddlHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_payment_information", event_label: "click:Add New Payment Method", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myPaymentInfoCCEditDeleteClickHandler(e) {
    var eventData = Object.assign({}, e === null || e === void 0 ? void 0 : e.detail);
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_payment_information", event_label: "click:Edit Delete Credit Card", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myPaymentInfoCCDeleteClickHandler(e) {
    var eventData = Object.assign({}, e === null || e === void 0 ? void 0 : e.detail);
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_payment_information", event_label: "click:Delete Credit Card", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myPaymentInfoCCDeleteHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_payment_information", event_label: "delete:Delete Credit Card", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myPaymentInfoCCDeleteCancelHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_payment_information", event_label: "cancel:Delete Credit Card", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myPaymentInfoCCEditSavelHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_payment_information", event_label: "edit:Edit Credit Card", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myPaymentInfoCCEditCancellHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_payment_information", event_label: "cancel:Edit Credit Card", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myPaymentInfoCCEditSaveErrorlHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject({
        supporter_id: eventData.supporter_id,
        error_message: eventData.errorMessage || "",
        error_type: eventData.errorType || "",
        page_errors: 1,
        total_errors: 1,
        event: "my_account_interactions",
        event_category: "my_account",
        event_action: "my_payment_information",
        event_label: eventData.errorMessage,
        ehash: ehash
    });
    dataLayerPush(dlEventData);
}
function myPaymentInfoEFTEditSavelHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_payment_information", event_label: "save:Edit EFT", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myPaymentInfoEFTCancellHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_payment_information", event_label: "cancel:Edit EFT", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myPaymentInfoEFTEditSaveErrorlHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject({
        supporter_id: eventData.supporter_id,
        error_message: eventData.errorMessage || "",
        error_type: eventData.errorType || "",
        page_errors: 1,
        total_errors: 1,
        event: "my_account_interactions",
        event_category: "my_account",
        event_action: "my_payment_information",
        event_label: eventData.errorMessage,
        ehash: ehash
    });
    dataLayerPush(dlEventData);
}
function myPaymentInfoCCEditClicklHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_payment_information", event_label: "click:Edit Credit Card", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myPaymentInfoEFTEditClicklHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_payment_information", event_label: "click:Edit EFT", ehash: ehash }));
    dataLayerPush(dlEventData);
}
/***************************
 * My Commitments Events
 ***************************/
/**
 * my_commitments_auto_pay_edit
 * my_commitments_auto_pay_edit_cancel
 * my_commitments_auto_pay_edit_save
 *
 * my_commitments_cash_donate_now_click
 * my_commitments_cash_donation_edit
 * my_commitments_cash_donation_edit_cancel
 * my_commitments_cash_donation_edit_save
 *
 * my_commitments_cash_donate_all_click
 *
 * my_commitments_update_error
 *
 */
function myCommitmentsAutoPayEditClicklHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_commitments", event_label: "click:Edit Auto Pay Donation", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myCommitmentsAutoPayEditCancelClicklHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_commitments", event_label: "cancel:Edit Auto Pay Donation", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myCommitmentsAutoPayEditSaveClicklHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_commitments", event_label: "save:Edit Auto Pay Donation", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myCommitmentsCashDonationDonateNowClicklHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject({
        supporter_id: eventData.supporter_id,
        event: "my_account_interactions",
        event_category: "my_account",
        event_action: "my_commitments",
        event_label: "click:Cash Donation Donate Now",
        ehash: ehash
    });
    dataLayerPush(dlEventData);
    var ecommDLEventData = normalizeObject(Object.assign({}, {
        supporter_id: eventData.supporter_id,
        event: "add_to_cart",
        event_action: "add_to_cart",
        event_category: "ecommerce",
        event_label: "cash_donation",
        ecommerce: {
            items: eventData.items
        },
        hi_add_to_carts: 1,
        high_intent_interactions: 1
    }));
    dataLayerPush({ ecommerce: null });
    dataLayerPush(ecommDLEventData);
}
function myCommitmentsCashDonationDonateAllClicklHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject({
        supporter_id: eventData.supporter_id,
        event: "my_account_interactions",
        event_category: "my_account",
        event_action: "my_commitments",
        event_label: "click:Cash Donation Donate All",
        ehash: ehash
    });
    dataLayerPush(dlEventData);
    var ecommDLEventData = normalizeObject(Object.assign({}, {
        event: "add_to_cart",
        event_action: "add_to_cart",
        event_category: "ecommerce",
        event_label: "cash_donations_donate_all",
        ecommerce: {
            items: eventData.items
        },
        hi_add_to_carts: 1,
        high_intent_interactions: 1
    }));
    dataLayerPush({ ecommerce: null });
    dataLayerPush(ecommDLEventData);
}
function myCommitmentsCashDonationEditClickHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_commitments", event_label: "click:Edit Cash Donation", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myCommitmentsCashDonationEditSaveHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_commitments", event_label: "save:Edit Cash Donation", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myCommitmentsCashDonationEditCancelHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_commitments", event_label: "cancel:Edit Cash Donation", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myCommitmentsUpdateErrorHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject({
        supporter_id: eventData.supporter_id,
        error_message: eventData.errorMessage || "",
        error_type: eventData.errorType || "",
        page_errors: 1,
        total_errors: 1,
        event: "my_account_interactions",
        event_category: "my_account",
        event_action: "my_commitments",
        event_label: eventData.errorMessage,
        ehash: ehash
    });
    dataLayerPush(dlEventData);
}
/***************************
 * My Giving History Events
 ***************************/
/**
 * my_giving_history_print
 * my_giving_history_view_by_year
 * my_giving_history_error
 */
function myGivingHistoryPrintHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_giving_history", event_label: "print:Giving History", utl_account_print_tax_receipts: 1, ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myGivingHistoryViewByYearHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject(__assign(__assign({}, eventData), { event: "my_account_interactions", event_category: "my_account", event_action: "my_giving_history", event_label: "view_giving_year:Giving History", ehash: ehash }));
    dataLayerPush(dlEventData);
}
function myGivingHistoryErrorHandler(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var dlEventData = normalizeObject({
        supporter_id: eventData.supporter_id,
        error_message: eventData.errorMessage || "",
        error_type: eventData.errorType || "",
        page_errors: 1,
        total_errors: 1,
        event: "my_account_interactions",
        event_category: "my_account",
        event_action: "my_giving_history",
        event_label: eventData.errorMessage,
        ehash: ehash
    });
    dataLayerPush(dlEventData);
}
export { myProfileChangeEmailClickHandler, myProfileChangePasswordClickHandler, myProfileCommPrefEditHandler, myProfileCommPrefSaveHandler, myProfileCommPrefCancelHandler, myProfileDonorProfileEditHandler, myProfileDonorProfileSaveHandler, myProfileDonorProfileCancelHandler, myPaymentInfoCCAddSavelHandler, myPaymentInfoCCAddCancellHandler, myPaymentInfoCCAddSaveErrorlHandler, myPaymentInfoEFTAddSavelHandler, myPaymentInfoEFTAddCancellHandler, myPaymentInfoEFTAddSaveErrorlHandler, myPaymentInfoAddlHandler, myPaymentInfoCCEditDeleteClickHandler, myPaymentInfoCCDeleteClickHandler, myPaymentInfoCCDeleteHandler, myPaymentInfoCCDeleteCancelHandler, myPaymentInfoCCEditSavelHandler, myPaymentInfoCCEditCancellHandler, myPaymentInfoCCEditSaveErrorlHandler, myPaymentInfoEFTEditSavelHandler, myPaymentInfoEFTCancellHandler, myPaymentInfoEFTEditSaveErrorlHandler, myPaymentInfoCCEditClicklHandler, myPaymentInfoEFTEditClicklHandler, myGivingHistoryPrintHandler, myGivingHistoryViewByYearHandler, myGivingHistoryErrorHandler, myCommitmentsAutoPayEditClicklHandler, myCommitmentsAutoPayEditCancelClicklHandler, myCommitmentsAutoPayEditSaveClicklHandler, myCommitmentsCashDonationDonateNowClicklHandler, myCommitmentsCashDonationDonateAllClicklHandler, myCommitmentsCashDonationEditClickHandler, myCommitmentsCashDonationEditSaveHandler, myCommitmentsCashDonationEditCancelHandler, myCommitmentsUpdateErrorHandler };
